import { apiSlice } from "../apiSlice";

export const mipuestoApiSlice = apiSlice.injectEndpoints({
  overrideExisting: true,
  endpoints: (builder) => ({
    getMipuestoPestanas: builder.query({
      query: () => ({
        url: `/Mipuesto/getPestanas`,
        method: "GET",
      }),
    }),
    getMipuestoMiDia: builder.query({
      query: () => ({
        url: `/Mipuesto/getMiDia`,
        method: "GET",
      }),
    }),
    getMipuestoContadores: builder.query({
      query: () => ({
        url: `/Mipuesto/getContadores`,
        method: "GET",
      }),
    }),
    agregarMipuestoPestana: builder.mutation({
      query: (parameters) => ({
        url: `/Mipuesto/pestanas`,
        method: "POST",
        body: parameters,
      }),
    }),
    quitarMipuestoPestana: builder.mutation({
      query: (parameters) => ({
        url: `/Mipuesto/pestanas/${parameters.MODIDXXX}/${parameters.PROIDXXX}`,
        method: "DELETE",
      }),
    }),
    ordenarMipuestoPestanas: builder.mutation({
      query: (parameters) => ({
        url: `/Mipuesto/pestanas/ordenar`,
        method: "PUT",
        body: parameters,
      }),
    }),
    getMipuestoWidgets: builder.query({
      query: () => ({
        url: `/Mipuesto/widgets`,
        method: "GET",
      }),
    }),
    getCatalogoDashboards: builder.query({
      query: () => ({
        url: `/Usuarios/Dashboar/catalogo`,
        method: "GET",
      }),
    }),
    agregarMipuestoWidget: builder.mutation({
      query: (parameters) => ({
        url: `/Mipuesto/widgets`,
        method: "POST",
        body: parameters,
      }),
    }),
    quitarMipuestoWidget: builder.mutation({
      query: (parameters) => ({
        url: `/Mipuesto/widgets/${parameters.GRAIDXXX}`,
        method: "DELETE",
      }),
    }),
    ordenarMipuestoWidgets: builder.mutation({
      query: (parameters) => ({
        url: `/Mipuesto/widgets/ordenar`,
        method: "PUT",
        body: parameters,
      }),
    }),
  }),
});

export const {
  useLazyGetMipuestoPestanasQuery,
  useLazyGetMipuestoContadoresQuery,
  useLazyGetMipuestoMiDiaQuery,
  useAgregarMipuestoPestanaMutation,
  useQuitarMipuestoPestanaMutation,
  useOrdenarMipuestoPestanasMutation,
  useLazyGetMipuestoWidgetsQuery,
  useLazyGetCatalogoDashboardsQuery,
  useAgregarMipuestoWidgetMutation,
  useQuitarMipuestoWidgetMutation,
  useOrdenarMipuestoWidgetsMutation,
} = mipuestoApiSlice;
